import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faTimes } from '@fortawesome/pro-light-svg-icons';
import { CircularProgress } from '@mui/material';

export const OfferCompliance = ({ isCompliant }) => {
    return <span>{isCompliant == null ? <CircularProgress color="inherit" size={"10px"}/> : isCompliant ?
        (<FontAwesomeIcon className="validationCompliance valid" icon={faCheckCircle} />) :
        (<FontAwesomeIcon className="validationCompliance invalid" icon={faTimesCircle} />)}
    </span>;
};

/**
*    @typedef {{
*    data: AllEmployeeOffersReportEntry;
*    onClose: ()=>void;
*    }} OfferDetailsProps
*    @param {OfferDetailsProps} param0
*/
export const OfferDetails = ({ data, onClose }) => {
    const { t: tReport } = useTranslation('employmentBillboard', { keyPrefix: 'billboard.allEmployeeReports' });
    if (!data) return null;

    return (
        <div className="mobile-row-slider">
            <div className="slider-header">
                <strong>{data.requestName}</strong>
                <button onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="slider-content">
                <p><span className="label">{tReport('request')}:</span><span className="value">{data.requestName}</span></p>
                <p><span className="label">{tReport('typeShort')}:</span><span className="value">{data.requestTypeLabel}</span></p>
                <p><span className="label">{tReport('initiator')}:</span><span className="value">{data.initiator}</span></p>
                <p><span className="label">{tReport('date')}:</span><span className="value">{data.requestStartDates}</span></p>
                <p><span className="label">{tReport('location')}:</span><span className="value">{data.location}</span></p>
                <p><span className="label">{tReport('shiftTime')}:</span><span className="value">{data.shiftTimeSort}</span></p>
                <p><span className="label">{tReport('segments')}:</span><span className="value">{data.segments}</span></p>
                <p>
                    <span className="label">{tReport('rulesValidationComplicance')}:</span>
                    <OfferCompliance isCompliant={data.rulesValidationComplicance} />
                </p>
            </div>
        </div>
    );
};
